import {LogoutOutlined, MenuOutlined} from '@ant-design/icons';
import {Avatar, Button, Divider, Drawer, Menu} from 'antd';
import {jwtDecode} from 'jwt-decode';
import PropTypes from 'prop-types';
import React, {useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link, NavLink, useLocation, useNavigate} from 'react-router-dom';

import logo from '../../../Assets/logo.jpeg';
import {RqEmployeeLookupById} from '../../../reactQuery/apis';
import {logoutStart} from '../../../redux/authAction';

const DrawerMenu = ({items}) => {
  const [open, setOpen] = useState(false);
  const [placement] = useState('left');

  const {loggedIn} = useSelector(state => state.auth);
  const location = useLocation();
  const auth = useSelector(state => state.auth);
  const token = auth?.tokenData;

  let id = null;
  if (token) {
    try {
      const decoded = jwtDecode(token);
      id = decoded?.userId;
    } catch {
      id = null;
    }
  }

  const navigate = useNavigate();
  const {data: profileDetails} = RqEmployeeLookupById(id, token, {
    enabled: loggedIn && !!id,
  });

  const skipRedirectRef = useRef(false);
  const dispatch = useDispatch();

  const showDrawer = () => setOpen(true);
  const onClose = () => setOpen(false);

  const handleLogout = () => {
    skipRedirectRef.current = true;
    dispatch(logoutStart());
    navigate('/');
  };

  return (
    <div className={'p-2'}>
      <Button
        icon={<MenuOutlined />}
        onClick={showDrawer}
        type={'text'}
        className={'text-xl'}
      />
      <Drawer
        title={null}
        placement={placement}
        size={200}
        onClose={onClose}
        open={open}
        styles={{display: 'none', padding: 0}}
      >
        <div className={'bg-primary-950 h-full text-white flex flex-col justify-between'}>

          {/* TOP: logo + nav menu */}
          <div>
            <div className={'h-16 flex items-center justify-center border-b border-gray-700'}>
              <div className={'w-full h-16 flex items-center justify-center'}>
                <img src={logo} alt={'logo'} className={'w-full h-full object-contain'} />
              </div>
            </div>
            <Divider className={'my-2'} />
            <Menu
              mode={'inline'}
              className={'bg-primary-950 mt-8'}
              selectedKeys={[location.pathname]}
            >
              {items.map((item, index) => (
                <React.Fragment key={index}>
                  <Menu.Item
                    key={item.path}
                    icon={item.icon}
                    onClick={() => {
                      onClose();
                      navigate(item.path);
                    }}
                    className={'!text-primary-50 bg-primary-950 text-base'}
                  >
                    {item.label}
                  </Menu.Item>
                  {index !== items.length - 1 && (
                    <Divider className={'my-2 border-gray-300'} />
                  )}
                </React.Fragment>
              ))}
            </Menu>
          </div>

          {/* BOTTOM: profile link + logout — matches admin sidebar */}
          <div className={'mb-6'}>
            <NavLink
              className={'w-full p-4 flex items-center gap-2'}
              to={'/admin/profile'}
              onClick={onClose}
            >
              <Avatar size={38} className={'bg-primary-50 w-1/3 text-primary-950 text-2xl'}>
                {profileDetails?.firstName?.[0]}
              </Avatar>
              <div className={'text-center w-2/3'}>
                <h4 className={'text-base text-primary-50 font-semibold capitalize'}>
                  {profileDetails?.firstName} {profileDetails?.lastName}
                </h4>
              </div>
            </NavLink>

            <Button
              onClick={handleLogout}
              className={'flex text-center bg-transparent border-none w-full hover:!bg-transparent hover:!border-none text-base text-primary-500 items-center gap-1'}
            >
              <LogoutOutlined /> logout
            </Button>
          </div>

        </div>
      </Drawer>
    </div>
  );
};

DrawerMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      path: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default DrawerMenu;
